export default {
  // Dashboard
  shipmentPerDay: '일 발송량',
  monthlyShipments: '월 발송량',
  currentMonth: '당월',
  previousMonth: '전월',
  ALIMTALK_BA: '알림톡B',
  ALIMTALK_EX: '알림톡E',
  ALIMTALK_AD: '알림톡A',
  ALIMTALK_MI: '알림톡M',
  FRIENDTALK_TEXT: '친구톡T',
  FRIENDTALK_IMAGE: '친구톡I',
  FRIENDTALK_WIDE_IMAGE: '친구톡W',
  FRIENDTALK_WIDE_ITEM_LIST: '친구톡WI',
  FRIENDTALK_COMMERCE: '친구톡C',
  FRIENDTALK_CAROUSEL_FEED: '친구톡CF',
  FRIENDTALK_CAROUSEL_COMMERCE: '친구톡CC',
  FRIENDTALK_PREMIUM_VIDEO: '친구톡P',
  sameDayShipment: '당일 발송량',
  currentMonthShipments: '당월 발송량',
  previousMonthShipments: '전월 발송량',
  dataCriteria: '데이터 기준',
  SMS: 'SMS',
  LMS: 'LMS',
  MMS: 'MMS',
  BRANDTALK_TEXT: '브랜드T',
  BRANDTALK_IMAGE: '브랜드I',
  BRANDTALK_WIDE_IMAGE: '브랜드W',
  BRANDTALK_WIDE_ITEM_LIST: '브랜드WI',
  BRANDTALK_COMMERCE: '브랜드C',
  BRANDTALK_CAROUSEL_FEED: '브랜드CF',
  BRANDTALK_CAROUSEL_COMMERCE: '브랜드CC',
  BRANDTALK_PREMIUM_VIDEO: '브랜드P',
};
